import { render, staticRenderFns } from "./ListAsetDihapusPage.vue?vue&type=template&id=1d5e6805"
import script from "./ListAsetDihapusPage.vue?vue&type=script&lang=js"
export * from "./ListAsetDihapusPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports